// extracted by mini-css-extract-plugin
export default {"mainContainer":"AuthorizedPersons_mainContainer__q3VJt","buttonContainer":"AuthorizedPersons_buttonContainer__IPj+i"};